import { useGetIdentity } from "@refinedev/core";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserIdentityData } from "types/props";

export const Home: React.FC = () => {
  const navigate = useNavigate();
  const { data: user } = useGetIdentity<UserIdentityData>();

  useEffect(() => {
    if (user?.role?.type === "external" || user?.role?.type === "client") {
      navigate("/jobs");
      return;
    }

    if (user?.role?.type === "admin") {
      navigate("/admin");
      return;
    }
  }, [navigate, user]);

  return <></>;
};
